import { getGlobalSelector } from './mmd';

const getRoot = () => getGlobalSelector().additionalSelectors.uiHelpersUtil;

export const milesToStringShort = (miles: number | string) => getRoot().milesToStringShort(miles);
